import React from 'react';
import ReactDOM from 'react-dom';

// import './init';
import './public';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
